import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import { detailsSettingsModalReducer } from './detailsSettingsModal/data/reducer';
import finalizeModalReducer from './finalizeModal/data/reducer';
import finalizeModalSaga from './finalizeModal/data/sagas';
import inviteModalReducer from './inviteModal/data/reducer';
import inviteModalSaga from './inviteModal/data/sagas';
import mergeModalReducer from './mergeModal/data/reducer';
import mergeModalSaga from './mergeModal/data/sagas';
import nestModuleReducer from './nestModuleModal/data/reducer';
import purchasedComponentUpdateCreateModalReducer from './purchasedComponentUpdateCreateModal/data/reducer';
import purchasedComponentUpdateCreateModalSaga from './purchasedComponentUpdateCreateModal/data/sagas';
import quoteViewsModalReducer from './quoteViewsModal/data/reducer';
import quoteViewsModalSaga from './quoteViewsModal/data/sagas';
import realTimeMaterialPricingModalReducer from './realTimeMaterialPricingModal/data/reducer';
import sesVerificationFailureModalReducer from './sesVerificationFailureModal/data/reducer';
import sesVerificationFailureModalSaga from './sesVerificationFailureModal/data/sagas';
import supplierMaterialModalReducer from './supplierMaterialModal/data/reducer';
import supplierMaterialModalSaga from './supplierMaterialModal/data/sagas';
import taskOverviewModalReducer from './taskOverviewModal/data/reducer';
import taskOverviewModalSaga from './taskOverviewModal/data/sagas';
import uploadDetailsModalReducer from './uploadDetailsModal/data/reducer';
import validateAddressModalReducer from './validateAddressModal/data/reducer';
import validateAddressModalSaga from './validateAddressModal/data/sagas';
import workflowStatusOverviewModalReducer from './workflowStatusOverviewModal/data/reducer';
import workflowStatusOverviewModalSaga from './workflowStatusOverviewModal/data/sagas';

export const reducer = combineReducers({
  detailsSettingsModal: detailsSettingsModalReducer,
  finalizeModal: finalizeModalReducer,
  inviteModal: inviteModalReducer,
  mergeModal: mergeModalReducer,
  purchasedComponentUpdateCreateModal:
    purchasedComponentUpdateCreateModalReducer,
  quoteViewsModal: quoteViewsModalReducer,
  realTimeMaterialPricingModal: realTimeMaterialPricingModalReducer,
  sesVerificationFailureModal: sesVerificationFailureModalReducer,
  supplierMaterialModal: supplierMaterialModalReducer,
  taskOverviewModal: taskOverviewModalReducer,
  uploadDetailsModal: uploadDetailsModalReducer,
  workflowStatusOverviewModal: workflowStatusOverviewModalReducer,
  validateAddress: validateAddressModalReducer,
  nestModule: nestModuleReducer,
});

export const saga = function* () {
  yield all([
    finalizeModalSaga(),
    mergeModalSaga(),
    quoteViewsModalSaga(),
    purchasedComponentUpdateCreateModalSaga(),
    sesVerificationFailureModalSaga(),
    supplierMaterialModalSaga(),
    taskOverviewModalSaga(),
    inviteModalSaga(),
    workflowStatusOverviewModalSaga(),
    validateAddressModalSaga(),
  ]);
};
